import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Newspaper, Plus } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { getAdminMembers, getAdminNews } from '../lib/api';

export default function DashboardPage() {
  const { accessToken } = useAuth();
  const [memberCount, setMemberCount] = useState<number | null>(null);
  const [newsCount, setNewsCount] = useState<number | null>(null);

  useEffect(() => {
    if (!accessToken) return;
    getAdminMembers(accessToken)
      .then(({ meta }) => setMemberCount(meta.total ?? null))
      .catch(() => {});
    getAdminNews(accessToken)
      .then(({ meta }) => setNewsCount(meta.total ?? null))
      .catch(() => {});
  }, [accessToken]);

  const stats = [
    {
      label: 'Members',
      value: memberCount,
      icon: <Users size={20} className="text-pink-400" />,
      href: '/members',
    },
    {
      label: 'News Articles',
      value: newsCount,
      icon: <Newspaper size={20} className="text-pink-400" />,
      href: '/news',
    },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-semibold text-gray-100">Dashboard</h1>
        <p className="mt-0.5 text-sm text-gray-500">Welcome back to Tsuyosa Admin.</p>
      </div>

      <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {stats.map((stat) => (
          <Link
            key={stat.label}
            to={stat.href}
            className="flex items-center gap-4 rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-5 transition-colors hover:border-pink-500/30"
          >
            <div className="rounded-lg bg-pink-500/10 p-2.5">{stat.icon}</div>
            <div>
              <p className="text-2xl font-bold text-gray-100">
                {stat.value === null ? '—' : stat.value}
              </p>
              <p className="text-xs text-gray-500">{stat.label}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-5">
        <h2 className="mb-4 text-sm font-medium text-gray-300">Quick Actions</h2>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/members/new"
            className="flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-80"
            style={{ backgroundColor: 'var(--tsuyosa-pink)' }}
          >
            <Plus size={16} />
            Add Member
          </Link>
          <Link
            to="/news/new"
            className="flex items-center gap-2 rounded-lg border border-pink-500/30 px-4 py-2 text-sm font-medium text-pink-400 transition-colors hover:bg-pink-500/10"
          >
            <Plus size={16} />
            Create Article
          </Link>
        </div>
      </div>
    </div>
  );
}
